module.exports = __webpack_public_path__ + "assets/img/00044.23e693dc.png";